var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-upload", {
    attrs: {
      action: _vm.action,
      "list-type": "picture-card",
      "file-list": _vm.fileList,
      accept: _vm.uploadAccept,
      data: {
        module: "auditAttachment"
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      },
      showUploadList: {
        showPreviewIcon: _vm.showPreviewIcon,
        showRemoveIcon: _vm.showRemoveIcon,
        showDownloadIcon: !_vm.showRemoveIcon
      }
    },
    on: {
      change: _vm.handleChange,
      preview: _vm.handlePreview,
      download: _vm.handleDownload
    }
  }, [_vm.showRemoveIcon ? _c("div", [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  }), _c("div", {
    staticClass: "ant-upload-text"
  }, [_vm._v(" " + _vm._s(_vm.$t("上传")) + _vm._s(_vm.partsType == "picture" ? _vm.$t("照片") : _vm.partsType == "enclosure" ? _vm.$t("附件") : "") + " ")])], 1) : _vm._e()]), _c("preview-modal", {
    attrs: {
      visible: _vm.previewVisible,
      videoTypeList: ["avi", "mov", "rm", "mp4", "rmvb"],
      fileList: _vm.fileList,
      show: _vm.isShow,
      src: _vm.previewSrc,
      currentIndex: _vm.currentPreviewIndex
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };